// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"_4b879961","infoItem":"_b531ebf","infoTextPrimary":"_1c9c41bb","infoTextSecondary":"_345cb34d"};